exports.BLOG_CONTEXT = require.context('./blog', true, /index\.(markdown|mdx)$/i);
